import { Box } from "@mui/material";
import { useMemo } from "react";
import { Navigate, Outlet, matchPath, useLocation, useParams } from "react-router-dom";

export function Facility() {
  const { tenantId, facilityId } = useParams<{
    tenantId: string;
    facilityId: string;
  }>();
  const { pathname } = useLocation();

  // The facility profile renders its own navigation (see FacilityHeaderV2), so
  // this route only needs the list of valid sub-paths to redirect an unmatched
  // path (e.g. the bare facility URL) to the profile.
  const tabPaths = useMemo(() => {
    const base = `/o/${tenantId}/facilities/${facilityId}`;
    return [
      `${base}/profile`,
      `${base}/tasks`,
      `${base}/echoInsights`,
      `${base}/rcraInsights`,
      `${base}/npdesInsights`,
      `${base}/contacts`,
      `${base}/documents`,
      `${base}/credentials`,
    ];
  }, [tenantId, facilityId]);

  const currentPath = tabPaths.find((to) => matchPath(`${to}/*`, pathname));

  // Redirect to the profile if we don't have a match
  if (!currentPath) {
    return <Navigate to={tabPaths[0]} replace={true} />;
  }

  return (
    <Box>
      <Outlet />
    </Box>
  );
}
